"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.staticAssertNever = void 0;
/**
 * Compile time assert that the given value should be of type never. This is
 * useful for guaranteeing all cases are handled in a switch statement.
 */
const staticAssertNever = (value) => value;
exports.staticAssertNever = staticAssertNever;
